import React, { useState } from 'react';

import { Window } from "../../contexts"
import { Select } from "../index.jsx"

const CountryInput = ({ field, form, ...props }) => {
    const suggestions = Window.COUNTRIES

    return (
        <Select
            field={field}
            form={form}
            options={suggestions}
            { ...props }
        />
    )
};

export default CountryInput;